var Controls = {
  _observer: null,

  mouseOverListener: function ( imgLink ) {
    Controls.displayTooltip ( imgLink );
  },

  mouseOutListener: function () {
    Controls.hideTooltip ();
  },

  displayTooltip: function ( imgLink ) {
    document.getElementById('tooltipContent').replaceChildren();
    var tooltip = document.createElement ( "div" );
    var fullImg = document.createElement ( "img" );

    fullImg.src = imgLink.src;
    fullImg.style.maxWidth = "400px";
    fullImg.style.border = "#3d465a solid 10px";
    tooltip.appendChild ( fullImg );
    tooltip.className = "imgTooltip";

    document.getElementById('tooltipContent').appendChild ( tooltip );

    // Observe tout le DOM pour détecter la suppression de l'img, quel que soit
    // le cas : suppression de valeur, scroll (virtualisation Handsontable),
    // rechargement/tri/filtre de la table, re-render de cellule.
    // L'observer est actif uniquement pendant que le tooltip est affiché,
    // donc l'impact sur les performances est négligeable.
    if (Controls._observer) {
      Controls._observer.disconnect();
    }
    Controls._observer = new MutationObserver(function () {
      if (!document.body.contains(imgLink)) {
        Controls.hideTooltip();
      }
    });
    Controls._observer.observe(document.body, { childList: true, subtree: true });
  },

  hideTooltip : function () {
    document.getElementById('tooltipContent').replaceChildren();
    if (Controls._observer) {
      Controls._observer.disconnect();
      Controls._observer = null;
    }
  }
};

export default Controls;
